import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { PathwayButton } from "./PathwayButtons";
import AlertComponent from "./Alerts/AlertComponent";
import PropTypes from "prop-types";

export const ModalInfo = (props) => {
    return (
        <Modal isOpen={props.isOpen} size={props.size}>
            <ModalHeader toggle={props.toggleModal}>{props.title}</ModalHeader>
            <AlertComponent errorMessages={props.message} />
            <ModalBody>{props.children}</ModalBody>
            <ModalFooter>
                <PathwayButton color="primary" onClick={props.toggleModal}>
                    {props.primaryButtonText}
                </PathwayButton>
            </ModalFooter>
        </Modal>
    );
};

ModalInfo.propTypes = {
    children: PropTypes.element.isRequired,
    isOpen: PropTypes.bool.isRequired,
    message: PropTypes.string,
    primaryButtonText: PropTypes.string.isRequired,
    size: PropTypes.any,
    title: PropTypes.string.isRequired,
    toggleModal: PropTypes.func.isRequired,
};
